import styled from 'styled-components'
import { Overlay, styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const MenuToggle = styled.button`
  ${styleReset}
  display: block;
  font-size: 3.5rem;
  padding: 0;
  cursor: pointer;

  &,
  svg {
    display: block;
    width: 1em;
  }

  ${mq.medium} {
    display: none;
  }
`

export const MenuBackdrop = styled.button`
  ${styleReset}
  ${Overlay}
  position: fixed;
  z-index: 10000;
`

export const MenuList = styled.ul`
  ${mq.smallOnly} {
    display: block;
    position: absolute;
    top: 100%;
    right: 0;
    width: max-content;
    max-width: calc(100vw - 2.6rem);
    margin: 0.3rem 0;
    padding: 0.8rem 0 0;
    font-family: ${theme.fonts.headings};
    color: #0f0f15;
    list-style: none;
    background-color: white;
    transform-origin: calc(100% - 2rem) -1rem;
    transform: translate3d(0, 0, 0);
    transition: transform 0.4s ${theme.ease.out}, opacity 0.2s ${theme.ease.out};
    counter-reset: menu;
    opacity: 0;
    pointer-events: none;
    z-index: 20000;

    &.enter {
      opacity: 0;
      transform: scale(0.8);
      pointer-events: auto;
    }

    &.enter-active,
    &.enter-done {
      opacity: 1;
      transform: translate3d(0, 0, 0);
      pointer-events: auto;
    }

    &.exit {
      opacity: 1;
      transform: translate3d(0, 0, 0);
      pointer-events: auto;
    }

    &.exit-active {
      opacity: 0;
      transform: scale(0.8);
    }
  }

  ${mq.medium} {
    padding: 0;
    margin: 0;
    white-space: nowrap;
    list-style: none;
    text-transform: uppercase;

    a {
      color: inherit;
      text-decoration: none;

      &:hover,
      &:focus {
        text-decoration: underline;
      }

      &.active {
        color: white;
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }
`

export const Li = styled.li`
  padding: 0;
  white-space: nowrap;
  counter-increment: menu;

  ${mq.smallOnly} {
    &:last-child {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    a {
      display: block;
      padding: 1rem 3rem 1rem 1.5rem;
      color: inherit;
      text-decoration: none;
      transition: background-color 0.3s;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover,
      &:focus {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  ${mq.medium} {
    display: inline-block;
    vertical-align: middle;
    padding-left: 3rem;

    &:first-child {
      padding: 0.4rem 2rem;
      margin-right: -1rem;
      border-right: 1px solid rgba(255, 255, 255, 0.3);
    }
  }

  svg {
    display: block;
    margin-top: -0.2rem;
  }
`

export const MobileMenuItem = styled(Li)`
  display: none;
  counter-increment: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  ${mq.smallOnly} {
    display: block;
  }

  a::before {
    content: '';
  }
`

export const FooterMenuItem = styled(Li)`
  border-top: 1px solid rgba(0, 0, 0, 0.1);

  a::before {
    content: '';
  }
`

export const MobileHidden = styled.span`
  ${mq.smallOnly} {
    display: none;
  }
`

export const MobileOnly = styled.span`
  ${mq.medium} {
    display: none;
  }
`
